import {
  ImpactDistributionDataEntry,
  useImpactDistributionChart,
} from "@jugl-web/domain-resources/analytics/components/ImpactDistributionWidget";
import { WidgetEmptyStateLabel } from "@jugl-web/domain-resources/analytics/components/WidgetEmptyStateLabel";
import { useTranslations } from "@jugl-web/utils";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { FC } from "react";
import { ReactComponent as TargetIcon } from "./assets/target.svg";
import { WidgetContainer } from "../WidgetContainer";
import { WidgetContainerTitle } from "../WidgetContainerTitle";

export const ImpactDistributionWidget: FC<{
  data: ImpactDistributionDataEntry[];
}> = ({ data }) => {
  const { t } = useTranslations();
  const { chartRef, options, isEmpty } = useImpactDistributionChart(data);

  return (
    <WidgetContainer className="flex h-[497px] flex-col items-stretch gap-8">
      <WidgetContainerTitle
        icon={<TargetIcon className="shrink-0" />}
        title={t({
          id: "cx-page.impact-distribution",
          defaultMessage: "Impact Distribution",
        })}
        subtitle={t({
          id: "cx-page.impact-distribution-subtitle",
          defaultMessage: "Sessions by Impact Category (%)",
        })}
      />
      <div className="min-h-0 w-full flex-1">
        {!isEmpty ? (
          <HighchartsReact
            ref={chartRef}
            highcharts={Highcharts}
            containerProps={{ className: "h-full w-full" }}
            options={options}
          />
        ) : (
          <div className="flex h-full items-center justify-center">
            <WidgetEmptyStateLabel />
          </div>
        )}
      </div>
    </WidgetContainer>
  );
};
